// extracted by mini-css-extract-plugin
export var dividerLine = "_9m-3";
export var itemImage = "_9m-9";
export var lightDivider = "_9m-4";
export var modalContent = "_9m-5";
export var modalContentCompact = "_9m-6";
export var productCard = "_9m-a";
export var productImage = "_9m-b";
export var productImageCompact = "_9m-7";
export var productImagePlaceholder = "_9m-c";
export var productImagePlaceholderCompact = "_9m-8";
export var progressBarBackground = "_9m-1";
export var progressBarContainer = "_9m-0";
export var progressBarFill = "_9m-2";